import { ProjectTemplateModel } from 'api/dto/ProjectTemplate.dto';
import { PaginationModel } from 'model/Pagination.dto';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'pulseSurveyTemplateLibrary';

export namespace PulseSurveyTemplateLibraryState {
  export type Domain = {
    listResource: Resource<ProjectTemplateModel[]>;
    listPagination: PaginationModel | null;
  };

  export const INITIAL_DOMAIN: Domain = {
    listResource: Resource.createPendingResource(),
    listPagination: null,
  };
}
